module.exports = __webpack_public_path__ + "static/media/9.0a57dde0.png";